// Formatadores puros compartilhados pelas páginas: máscaras de documento/contato,
// normalização de data para input e exibição em pt-BR. Recebem e retornam string.

// Mantém só os dígitos da string.
export function onlyDigits(value) { return (value || '').replace(/\D/g, ''); }

// Aplica máscara de CNPJ (00.000.000/0000-00), limitando a 14 dígitos.
export function formatCnpj(value) {
  const digits = onlyDigits(value).slice(0, 14);
  if (!digits) return '';
  if (digits.length <= 2) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
  if (digits.length <= 8) return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5)}`;
  if (digits.length <= 12) return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8)}`;
  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12)}`;
}

// Aplica máscara de CPF (000.000.000-00), limitando a 11 dígitos.
export function formatCpf(value) {
  const digits = onlyDigits(value).slice(0, 11);
  if (!digits) return '';
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
  if (digits.length <= 9) return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
}

// Aplica máscara de CEP (00000-000), limitando a 8 dígitos.
export function formatCep(value) {
  const digits = onlyDigits(value).slice(0, 8);
  if (!digits) return '';
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

// Aplica máscara de telefone ((00) 0000-0000 ou (00) 00000-0000).
export function formatPhone(value) {
  const digits = onlyDigits(value).slice(0, 11);
  if (!digits) return '';
  if (digits.length <= 2) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}

// Detecta tecla de controle (Ctrl/Cmd/Alt) para liberar atalhos nos campos com máscara.
export function isControlKey(event) { return event.ctrlKey || event.metaKey || event.altKey; }

// Sincroniza formatos de data para YYYY-MM-DD entre APIs diferentes.
export function normalizeDateOnly(value) {
  if (!value) return '';
  const asString = String(value);
  if (/^\d{4}-\d{2}-\d{2}$/.test(asString)) return asString;
  if (/^\d{4}-\d{2}-\d{2}T/.test(asString)) return asString.slice(0, 10);

  const parsed = new Date(asString);
  if (Number.isNaN(parsed.getTime())) return '';
  const pad = (num) => String(num).padStart(2, '0');
  return `${parsed.getFullYear()}-${pad(parsed.getMonth() + 1)}-${pad(parsed.getDate())}`;
}

// Exibe data no padrão brasileiro sem alterar o formato interno usado em filtros/payload.
export function formatDateBr(value) {
  if (!value) return '-';
  const asString = String(value);

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(asString)) return asString;

  if (/^\d{4}-\d{2}-\d{2}$/.test(asString)) {
    const [year, month, day] = asString.split('-');
    return `${day}/${month}/${year}`;
  }

  const parsed = new Date(asString);
  if (Number.isNaN(parsed.getTime())) return asString;
  return parsed.toLocaleDateString('pt-BR');
}
